<template>
  <div class="relative flex justify-end items-center">
    <button @click="isOpen = !isOpen" v-click-outside="setOpenToFalse"  id="project-options-menu-0" aria-haspopup="true" type="button" class="w-8 h-8 bg-white inline-flex items-center justify-center text-gray-400 rounded-full hover:text-gray-500 focus:outline-none  focus:ring-offset-2 focus:ring-purple-500">
      <span class="sr-only">Open options</span>
      <!-- Heroicon name: dots-vertical -->
      <svg class="w-5 h-5 text-pink" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
        <path d="M10 6a2 2 0 110-4 2 2 0 010 4zM10 12a2 2 0 110-4 2 2 0 010 4zM10 18a2 2 0 110-4 2 2 0 010 4z" />
      </svg>
    </button>

    <transition
        name="custom-classes-transition"
        enter-class="transition ease-out duration-100 transform"
        enter-active-class="opacity-0 scale-95"
        enter-to-class="opacity-100 scale-100"
        leave-class="transition ease-in duration-75 transform"
        leave-active-class="opacity-100 scale-100"
        leave-to-class="opacity-0 scale-95"
    >
      <div  v-if="isOpen"
            class="mx-3 origin-top-right absolute right-7 top-0 w-48 mt-1 shadow-lg z-10 bg-white ring-1 ring-black ring-opacity-5 divide-y divide-gray-200" role="menu" aria-orientation="vertical" aria-labelledby="project-options-menu-0">

        <div class="py-1" role="none">

          <a :href="`/admin/deposits/`+deposit.id" class="group flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900" role="menuitem">
            <!-- Heroicon name: pencil-alt -->
            <svg class="mr-3 h-5 w-5 text-pink-500 group-hover:text-pink-700" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
              <path d="M17.414 2.586a2 2 0 00-2.828 0L7 10.172V13h2.828l7.586-7.586a2 2 0 000-2.828z" />
              <path fill-rule="evenodd" d="M2 6a2 2 0 012-2h4a1 1 0 010 2H4v10h10v-4a1 1 0 112 0v4a2 2 0 01-2 2H4a2 2 0 01-2-2V6z" clip-rule="evenodd" />
            </svg>
            Edit
          </a>
        </div>

      </div>
    </transition>
  </div>
</template>

<script>
  export default {
    props: {
      deposit: null,
    },
    data() {
      return {
        isOpen: false,
      }
    },
    methods: {
      setOpenToFalse() {
        this.isOpen = false;
      },
    }
  }
</script>

<style scoped>

</style>
